module.exports = {
    bindings: { 
        activeRuling: '<' 
    },
    controller: customsRulingDetailsController,
    templateUrl: 'cross/components/customs-ruling-details.html'
}

customsRulingDetailsController.$inject = [
    'crossDataService'
];

function customsRulingDetailsController(
    crossDataService
) {

    var vm = {
        changeActiveRuling: changeActiveRuling
    };

    return vm;

    function changeActiveRuling(rulingNumber, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        crossDataService.changeActiveRuling(rulingNumber);
    }
}